import type { DataRoute, Threshold } from 'flow/store/engine/types';

export function isDataRoute(data: Threshold | DataRoute): data is DataRoute {
  return 'targetId' in data;
}
